module.exports = __webpack_public_path__ + "static/media/segmento-moda.4eb64233.gif";